import ToggleSwitch from '../../atoms/ToggleSwitch/ToggleSwitch';
import './NotificationToggle.scss';

interface NotificationToggleProps {
    label: string;
    checked: boolean;
    onChange: (value: boolean) => void;
}

const NotificationToggle = (props: NotificationToggleProps) => {
    return (
        <div className="notification-toggle">
            <span>{props.label}</span>
            <div className="notification-toggle-switch">
                <ToggleSwitch checked={props.checked} onChange={checked => props.onChange(checked)} />
            </div>
        </div>
    );
}

export default NotificationToggle;